import { useQuery } from "@tanstack/react-query";
import { profileAPI } from "../profileAPI.ts";

export const useGetProfileQuery = () => {
  return useQuery ({
    queryKey: ["profile"],
    queryFn: () => profileAPI.getProfile(),
    staleTime: 30 * 60 * 1000, // 30мин
    gcTime: 60 * 60 * 1000, // 60мин
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
  });
};
